import { useSearchParams } from 'react-router-dom';

const TAB_SEARCH_PARAM_NAME = 'tab';

export function useTabSearchParam(
  validTabIds: readonly string[],
  defaultTabId: string
): [string, (nextTabId: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTabId = searchParams.get(TAB_SEARCH_PARAM_NAME);
  const activeTabId =
    requestedTabId !== null && validTabIds.includes(requestedTabId)
      ? requestedTabId
      : defaultTabId;

  function setActiveTabId(nextTabId: string) {
    setSearchParams(
      function updateParams(currentParams) {
        const nextParams = new URLSearchParams(currentParams);
        nextParams.set(TAB_SEARCH_PARAM_NAME, nextTabId);
        return nextParams;
      },
      { replace: true }
    );
  }

  return [activeTabId, setActiveTabId];
}
